export const theme = {
  colors: {
    primary: 'rgba(113, 82, 243, 1)',
    secondary: 'rgba(244, 91, 105, 1)',
    background: 'rgba(255, 255, 255, 1)',
    text: 'rgba(22, 21, 28, 1)'
  },

  fonts: {
    body: "Lexend",
    heading: "Lexend",
    fontSize:11
  }

};
 